export enum TSRole {
    SUPER_ADMIN = <any> 'SUPER_ADMIN',
    FONDSSUISSE_ADMIN = <any> 'FONDSSUISSE_ADMIN',
    FONDSSUISSE_SACHBEARBEITER= <any> 'FONDSSUISSE_SACHBEARBEITER',
    ANLAUFSTELLE_VERWALTER = <any> 'ANLAUFSTELLE_VERWALTER',
    ANLAUFSTELLE_SACHBEARBEITER = <any> 'ANLAUFSTELLE_SACHBEARBEITER',
    ANLAUFSTELLE_SCHAETZER= <any> 'ANLAUFSTELLE_SCHAETZER',
    KANTON_VERWALTER= <any> 'KANTON_VERWALTER',
    KANTON_INSPEKTOR= <any> 'KANTON_INSPEKTOR',
    BETROFFENER = <any> 'BETROFFENER',
    UNASSIGNED_ROLE = <any> 'UNASSIGNED_ROLE',
}

export function getTSRoleValues(): Array<TSRole> {
    return [
        TSRole.SUPER_ADMIN,
        TSRole.FONDSSUISSE_ADMIN,
        TSRole.FONDSSUISSE_SACHBEARBEITER,
        TSRole.ANLAUFSTELLE_SACHBEARBEITER,
        TSRole.ANLAUFSTELLE_VERWALTER,
        TSRole.ANLAUFSTELLE_SCHAETZER,
        TSRole.KANTON_VERWALTER,
        TSRole.KANTON_INSPEKTOR,
        TSRole.BETROFFENER,
        TSRole.UNASSIGNED_ROLE,
    ];
}

export function rolePrefix(): string {
    return 'TSRole_';
}





// WEBPACK FOOTER //
// ./src/app/models/enums/TSRole.ts